import { createFileRoute } from "@tanstack/react-router";
import SportSlatePage from "@/pages/SportSlatePage";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta, readable } from "@/lib/routeSocial";
import { findUsSport } from "@/lib/oddsSports";

export const Route = createFileRoute("/{$sport}-predictions/tomorrow")({
  head: ({ params }) => {
    const sport = findUsSport(params.sport);
    const label = sport?.label ?? readable(params.sport);
    return {
      meta: socialMeta({
        seo: { topics: [params.sport, "predictions"] },
        title: `${label} Predictions Tomorrow: Picks & Odds | Statlign`,
        description: `${label} picks for tomorrow's games: model probability, live odds and the value edge on every pick, with the reasoning shown.`,
        ...(sport ? { image: `https://statlign.com/og-${sport.slug}.jpg` } : {}),
      }),
    };
  },
  component: () => (
    <MainLayout>
      <SportSlatePage variant="tomorrow" />
    </MainLayout>
  ),
});
